var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,class:['border-stepper', {'active-border': _vm.isActive(i)}]},[_c('div',{class:['d-none', {'active-text': _vm.isActive(i)}]},[_vm._v(" "+_vm._s(item)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }